import React, { FormEvent, useCallback, useState } from "react";
import useApi from "../../../hooks/useApi";
import { SubmitButton } from "../../../Korbantech/components/Buttons/SubmitButton";
import { SuccessAlert } from "../../Alerts/SuccessAlert";
import { OscInput } from "../OscInputs/OscInput";

export const PasswordField = () => {

    const api = useApi()

    const [success,setSuccess] = useState<boolean>();

    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.currentTarget.checkValidity()
        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget) 

            data.append('_method', 'PATCH')
            return await api.post(`/client/me/password`, data).then(res => {
                 setSuccess(true)
            }).catch(console.log)
    }, [api])

    return(
        <form onSubmit={handleSubmit} className={'mb-4'}>
            {success && <SuccessAlert message="Senha alterada" closeAlert={()=>setSuccess(false)}/>}
            <div className='font-semibold text-xl mb-2'>Alterar Senha</div>
            <div className="border-l-4 border-green-600 pl-4 pr-4 rounded-lg flex flex-col gap-y-3">
            <div className="grid grid-cols-2 gap-x-6 ">
              <OscInput label={'Nova Senha'} type="password" name='password'
                            necessary />
               <OscInput label={'Confirmar senha'} type="password" name='password_confirmation' necessary />
            </div>
            <div className="w-3/12 self-end">
                <SubmitButton value="Alterar Senha"/>
            </div>
            </div>
        </form>
    )
}